import { apiClient } from "../config/env";

// 계약자 관리
export function fetchContractorDetail(contractorId) {
  return apiClient.get(`/settings/contractor/${contractorId}`);
}
export function fetchContractorList(params) {
  return apiClient.get(`/settings/contractor`, { params });
}
export function createContractor(data, contractorId) {
  return apiClient.post(`/settings/contractor/${contractorId}`, data);
}
export function updateContractor(data, contractorId) {
  return apiClient.put(`/settings/contractor/${contractorId}`, data);
}
export function deleteContractor(contractorId) {
  return apiClient.delete(`/settings/contractor/${contractorId}`);
}
export function getContractorId(params) {
  return apiClient.get(`/settings/contractor/make/idx`, { params });
}
export function resetContractorPassword(contractorId) {
  return apiClient.put(`/settings/contractor/${contractorId}/reset-password`);
}
export function createUserAccount(contractorId, data) {
  return apiClient.post(`/settings/contractor/${contractorId}/create-user`, data);
}

// 계약 관리
export function fetchContractDetail(contractId) {
  return apiClient.get(`/settings/contract/${contractId}`);
}
export function fetchContractList(params) {
  return apiClient.get(`/settings/contract`, { params });
}
export function createContract(data, contractId) {
  return apiClient.post(`/settings/contract/${contractId}`, data);
}
export function updateContract(data, contractId) {
  return apiClient.put(`/settings/contract/${contractId}`, data);
}
export function deleteContract(contractId) {
  return apiClient.delete(`/settings/contract/${contractId}`);
}
export function getContractId(params) {
  return apiClient.get(`/settings/contract/make/idx`, { params });
}

// 앨범 관리
export function fetchAlbumDetail(albumId) {
  return apiClient.get(`/settings/album/${albumId}`);
}
export function fetchAlbumList(params) {
  return apiClient.get(`/settings/album`, { params });
}
export function createAlbum(albumId, data) {
  return apiClient.post(`/settings/album/${albumId}`, data);
}
export function updateAlbum(albumId, data) {
  return apiClient.put(`/settings/album/${albumId}`, data);
}
export function deleteAlbum(albumId) {
  return apiClient.delete(`/settings/song/${albumId}`);
}

// 음원 관리
export function fetchSongDetail(songId) {
  return apiClient.get(`/settings/song/${songId}`);
}
export function fetchSongList(params) {
  return apiClient.get(`/settings/song`, { params });
}
export function createSong(songId, data) {
  return apiClient.post(`/settings/song/${songId}`, data);
}
export function updateSong(songId, data) {
  return apiClient.put(`/settings/song/${songId}`, data);
}
export function deleteSong(songId) {
  return apiClient.delete(`/settings/song/${songId}`);
}

// 권한 관리
export function fetchRoleDetail(params) {
  return apiClient.get(`/settings/role/${params.role_name}`, { params });
}
export function fetchRoleList(params) {
  return apiClient.get(`/settings/role`, { params });
}
export function createRole(data) {
  return apiClient.post(`/settings/role`, data);
}
export function updateRole(roleName, data) {
  return apiClient.put(`/settings/role/${roleName}`, data);
}
export function deleteRole(roleName) {
  return apiClient.delete(`/settings/role/${roleName}`);
}

// 공지사항 관리
export function fetchNoticeDetail(params) {
  return apiClient.get(`/settings/notice/${params.idx}`, { params });
}
export function fetchNoticeList(params) {
  return apiClient.get(`/settings/notice`, { params });
}
export function createNotice(data) {
  return apiClient.post(`/settings/notice`, data);
}
export function updateNotice(idx, data) {
  return apiClient.put(`/settings/notice/${idx}`, data);
}
export function deleteNotice(idx) {
  return apiClient.delete(`/settings/notice/${idx}`);
}

//엑셀 업로드
export function fetchExcelUploadList(params) {
  return apiClient.get(`/settings/excel/upload/list`, { params });
}

// S3 Presigned URL 요청
export function getPresignedUrl(fileName, fileType, email) {
  return apiClient.get(`/settings/excel/upload/presigned-url`, {
    params: {
      fileName: fileName,
      fileType: fileType,
      email: email,
    },
  });
}

// S3에서 파일 다운로드 후 처리 요청
export function processS3File(fileName, originalFileName, fileType, email) {
  return apiClient.post(`/settings/excel/upload/process`, null, {
    params: {
      fileName: fileName, // S3 Key
      originalFileName: originalFileName, // 원본 파일명 (파싱용)
      fileType: fileType,
      email: email,
    },
    timeout: 900000, // 15분 (900초) - 백엔드 파일 처리 시간 고려
  });
}

// 기존 업로드 방식 (레거시, 사용 안 함)
export function fetchExcelUpload(formData) {
  // FormData를 사용할 때는 Content-Type을 명시하지 않음 (브라우저가 자동으로 boundary 포함하여 설정)
  return apiClient.post(`/settings/excel/upload`, formData);
}

export function fetchExcelDownload(params) {
  return apiClient.get(`/settings/excel/download`, {
    params,
    responseType: "blob",
  });
}

// 월별/서비스월별 매출
export function fetchSalesMonth(params) {
  return apiClient.get(`/settings/sales/month`, { params });
}
// 계약자별 매출
export function fetchSalesContractors(params) {
  return apiClient.get(`/settings/sales/contractors`, { params });
}
// 아티스트별 매출
export function fetchSalesArtists(params) {
  return apiClient.get(`/settings/sales/artists`, { params });
}
// 앨범별 매출
export function fetchSalesAlbums(params) {
  return apiClient.get(`/settings/sales/albums`, { params });
}
// 곡별 매출
export function fetchSalesSongs(params) {
  return apiClient.get(`/settings/sales/songs`, { params });
}

// 플랫폼별 매출
export function fetchSalesPlatform(params) {
  return apiClient.get(`/settings/sales/platform`, { params });
}

// 전체 계약자 정산 현황 조회
export function fetchAllSettlementStatus(params) {
  return apiClient.get(`/accounts/artist/all`, { params });
}
// 전체 일괄 정산 대상금 확정
export function confirmAllSettlement(data) {
  return apiClient.post(`/accounts/artist/amount/confirm/all`, data);
}

// 프로모션 관리
export function fetchPromotionDetail(params) {
  return apiClient.get(`/settings/promotion/${params.idx}`, { params });
}
export function fetchPromotionList(params) {
  return apiClient.get(`/settings/promotion`, { params });
}
export function createPromotion(data) {
  return apiClient.post(`/settings/promotion`, data);
}
export function updatePromotion(idx, data) {
  return apiClient.put(`/settings/promotion/${idx}`, data);
}
export function deletePromotion(idx) {
  return apiClient.delete(`/settings/promotion/${idx}`);
}
